import { render } from "./Carros.vue?vue&type=template&id=f102a0e2"
import script from "./Carros.vue?vue&type=script&lang=js"
export * from "./Carros.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__